import { Injectable, signal } from '@angular/core';

import { CurrentUser } from '../../core/api/models/account.models';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  readonly currentUser = signal<CurrentUser | null>(null);

  setCurrentUser(user: CurrentUser): void {
    this.currentUser.set(user);
  }
}
